<template>
  <div>
    <Poptip trigger="click" placement="bottom-end" v-model="visible">
      <div class="scmcc-user-center-entry">
        <Avatar icon="ios-person" v-if="avatarUrlRight==''"/>
        <Avatar :src="avatarUrl" v-if="avatarUrlRight!==''"/>
        <span class="scmcc-user-center-entry-name">{{
          $store.state.main.user.info.userName
        }}</span>
        <Icon type="ios-arrow-down" />
      </div>
      <template  v-slot:content>
        <div class="scmcc-user-center-entry-panel">
          <p class="nickClass">
            <span>{{ $store.state.main.user.info.userName }}</span
            >
          </p>
          <p class="iPCass">
            当前IP&nbsp;:&nbsp;{{ $store.state.main.user.info.userIp }}
          </p>
          <div class="personnalmess" @click="editPersonnalmess">
            <CIcon
              icon="gerenxinxi" style="margin-right:10px"
            ></CIcon
            >个人信息
          </div>
          <div class="editPassWord" @click="editPassWordPage">
            <CIcon
              icon="kehuzhongxin-xiugaimima" style="margin-right:10px"
            ></CIcon
            >修改密码
          </div>
          <div class="logoutBtn" @click="submitLogout">
            <CIcon
              icon="kehuzhongxin-tuichudenglu" style="margin-right:10px"
            ></CIcon
            >注销登录
          </div>
        </div>
      </template>
    </Poptip>
    <Modal
        v-model="confirmLoginout"
        width="400"
        :mask-closable="maskClosable"
        title="是否确认退出当前账户"
        @on-ok="_confirmLoginout"
        @on-cancel="cancel">
        <div>退出后继续使用外部号码接听来电</div>
        
      
    </Modal>
  </div>
</template>
<script>
//TODO: 用户名过长文字需截断。
import envConst from '@/env-const.js'
export default {
  name: 'userCenterEntry',
  data() {
    return {
      avatarUrlRight:'',
      confirmLoginout:false,
      maskClosable:false,
      visible:false
    }
  },
   watch: {
    '$store.state.main.attachmentId': {
      handler(val) {
        console.log("222",val)
      //  this.getAvatarUrl()
      },
      immediate: true
    }
  },
  computed: {
    avatarUrl() {
     return  envConst.API_BASE_URL + this.avatarUrlRight
    
    }
  },
  created() {
    // this.getAvatarUrl()
    this.$eventBus.on('SCTM_LOGIN_ELSEWHERE', data => {
      // squeezed标记当前用户是否被其他登录挤掉，'0' = 否，'1' = 是
      sessionStorage.isSqueezed = '1'
      this.submitLogout()
    })
    this.$eventBus.on('SCTM_LOGIN_EXPIRE', data => {
      // loginTimeout标记当前用户是否超时，'0' = 否，'1' = 是
      sessionStorage.isLoginTimeout = '1'
      this.submitLogout()
    })
  },
  methods: {
    getAvatarUrl(){
       this.$http.get('/sctm/user/getuserimg').then(res =>{
        if(res.data.returnCode == 0){
          this.avatarUrlRight = res.data.bean
        }else{
          this.$Message.error('头像地址查询失败');
        }
      }).catch( res => {
         this.$Message.error('头像地址查询失败');
      })
    },
    submitLogout() {
      // this.confirmLoginout = true;
        this.$http.get('/sctm/user/getpersonalcenter').then(res =>{
          if(res.data.returnCode == 0){
            if(res.data.bean.outPhone==1){
              let params={};
              params.tenantId = JSON.parse(localStorage.user).info.tenantId;
              params.agentId = JSON.parse(localStorage.user).info.agentId;
              this.$http.post('/sccs/getAgentOutPhoneOrMode',params).then(res1 => {//查询是否是外部号码接听
                if(res1.data.returnCode == 0){
                   console.log(res1.data)
                  if(res1.data.bean.answerMode == 1){
                    this.visible = false;
                    let phoneNum = '';
                    if(res1.data.bean.agentOutPhone == ''|| res1.data.bean.agentOutPhone==undefined){
                      phoneNum = JSON.parse(localStorage.user).info.contactPhone;
                    }else{
                      phoneNum = res1.data.bean.agentOutPhone
                    }
                    this.$Modal.confirm({
                        title: '是否确认退出当前账户',
                        content: '退出后将继续使用外部号码'+phoneNum+'接听来电，如不继续使用外部号码接听，请至个人中心修改接听方式为“系统接听”。',
                        onOk: () => {
                            this._confirmLoginout();
                        },
                        onCancel: () => {
                            
                        }
                    });
                  }else{
                    this._confirmLoginout();
                  }
                }
              }).catch(err=>{
                // this._confirmLoginout();
              })
            }else{
              this._confirmLoginout();
            }
          }else{
            this._confirmLoginout();
          }
        }).catch(err=>{
          this._confirmLoginout();
        })
     
    },
    _confirmLoginout(){
      this.$eventBus.emit('scmcc/logout')
    },
    editPassWordPage() {
      document.querySelector('.ivu-poptip-popper').style.display = 'none'
      this.$router.push({ name: 'scbf_ui/updatePassword' }).catch(err => {})
    },
    editPersonnalmess() {
      document.querySelector('.ivu-poptip-popper').style.display = 'none'
      this.$router.push({ name: 'personnalMess' }).catch(err => {})
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.forceEndAllCvs)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.forceEndAllCvs)
  }
}
</script>
<style lang="stylus">
.scmcc-user-center-entry
  display flex
  align-items center
  position relative

  .scmcc-user-center-entry-name
    margin 0 12px 0 8px

.scmcc-user-center-entry-icon
  width 20px
  height 20px
  display inline-block
  vertical-align middle

.scmcc-user-center-entry-icon-password
  margin-right 2px
  background-image url('../assets/images/login-page/ico_mima@2x.png')
  background-repeat no-repeat
  background-size 15px
  background-position center center

.scmcc-user-center-entry-panel
  color #90959E

  .nickClass
    color #515A6E
    font-size 14px
    display inline-block
    margin-bottom 12px

  .roleCass
    margin-bottom 10px

  .iPCass
    margin-bottom 24px

.scmcc-user-center-entry-icon-logout
  margin-right 2px
  background-image url('../assets/images/userCenterEntry-page/logout-icon.png')

.editPassWord
  padding 6px 0
  display flex
  align-items center
  cursor pointer

.personnalmess
  padding 12px 0 6px
  border-top 1px solid #D9E1F6
  display flex
  align-items center
  cursor pointer

.logoutBtn
  padding 6px 0 
  cursor pointer

</style>


